

export const routes = {
    BLOCKED_NUMBER: {
        METHOD: 'POST',
        URL: '/blockNumber',
    },
    DELETE_NUMBER: {
        METHOD: 'POST',
        URL: '/blockNumber/delete',
    },
}